import _ from 'underscore';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const KEYS = {
  ESC: 27,
  SPACE: 32,
};

/**
 * dropdown button component, provide the funtions of:
 * toggle
 * render the selected item info
 */
export class DropdownBtnComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.dropdownContentId = _.uniqueId('dropdown-content-');
  }

  /**
   * handle the keydown action in the dropdown button
   * @param {object} event the keydown event
   * @returns {undefined}
   */
  handleKeyDown = (event) => {
    const { handleClickOutside } = this.props.dropdownOptions;
    if ((event.keyCode === KEYS.ESC || event.keyCode === KEYS.SPACE)
        && _.isFunction(handleClickOutside)) {
      handleClickOutside();
    }
  }

  /**
   * render the dropdown btn when selected item is null
   * @returns {Object} will return the  dropdown btn component
   */
  renderEmptyDropdownText = () => {
    const { i18n, dropdownOptions } = this.props;
    if (dropdownOptions.renderEmptyDropdownText) {
      return dropdownOptions.renderEmptyDropdownText();
    }
    const defaultDropdownText = i18n.getString(_TL_('Select an item'));
    return defaultDropdownText;
  }

  /**
   * when the customized renderDropdownText is null, will update the btn with default content
   * @param {object} item the item selected
   * @returns {Object} will return the default dropdown text component
   */
  renderDefaultDropdownText = item => (
    <span>
      {item ? item.name : ''}
    </span>
  );

  /**
   * render the dropdown btn
   * @returns {Object} will return the  dropdown btn component
   */
  renderDropdownContent = () => {
    const { selectedItem, renderDropdownText } = this.props.dropdownOptions;
    if (!selectedItem) {
      return this.renderEmptyDropdownText();
    }
    if (!renderDropdownText) {
      this.renderDefaultDropdownText(selectedItem);
    }
    return renderDropdownText(selectedItem);
  }

  render() {
    const {
      selectedItem, toggle, isToggled, ariaLabel, disabled,
    } = this.props.dropdownOptions;

    return (
      <button
        className="btn btn-default dropdown-toggle"
        type="button"
        tabIndex="0"
        aria-haspopup
        aria-expanded={isToggled ? 'true' : 'false'}
        aria-label={ariaLabel}
        aria-describedby={this.dropdownContentId}
        disabled={disabled}
        onClick={toggle}
        onKeyDown={this.handleKeyDown}
      >
        <span className="selected-item" id={this.dropdownContentId}>
          {this.renderDropdownContent()}
        </span>
        <div
          className={classnames('icon-right', {
            'glyphicon glyphicon-triangle-bottom': !selectedItem,
            'glyphicon glyphicon-pencil': selectedItem,
          })}
        />
      </button>
    );
  }
}

DropdownBtnComponent.propTypes = {

  /**
   * i18n for the initail tips to show
   */
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,

  dropdownOptions: PropTypes.shape({
    /**
    * current selected item which sholud show on this component
    */
    selectedItem: PropTypes.objectOf(PropTypes.any),
    /**
     * callback function when user toggled
     */
    toggle: PropTypes.func.isRequired,
    /**
     * current toggle status
     */
    isToggled: PropTypes.bool.isRequired,
    /**
     * render the dropdown text
     */
    renderDropdownText: PropTypes.func,
    /**
     * render the dropdown text when not selected
     */
    renderEmptyDropdownText: PropTypes.func,
    /**
     * handle click outside
     */
    handleClickOutside: PropTypes.func.isRequired,
    /**
     * aria-label
    */
    ariaLabel: PropTypes.string,
    /**
     * disable the dropdown menu
     */
    disabled: PropTypes.bool,
  }).isRequired,
};
